const PLACEHOLDER_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 112 112" fill="none" stroke="#D1D5DB" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"><rect x="26" y="40" width="60" height="42" rx="6"/><path d="M43 40v-4a4 4 0 0 1 4-4h18a4 4 0 0 1 4 4v4"/><circle cx="56" cy="61" r="13"/><path d="M30 30 82 90"/></svg>`

export const PRODUCT_IMAGE_PLACEHOLDER = `data:image/svg+xml,${encodeURIComponent(
  PLACEHOLDER_SVG
)}`

export function productImageSrc(image) {
  const url = typeof image === "string" ? image : image?.url
  return url || PRODUCT_IMAGE_PLACEHOLDER
}
